import React from "react";

import Modal from "../../../../components/elements/Modal";
import ManageTask from "../ManageTask";

const ManageTaskodal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl2"
      title={data?._id ? "Update One" : "Create New"}
    >
      <ManageTask getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageTaskodal;
